.bk{flex-shrink:0;}